// @flow
import { all, call } from "redux-saga/effects";
import type { Saga } from "redux-saga";
import getPwa from "../../sagas/getPwaMotivationContent";

export default function* mainSaga(): Saga<void> {
  yield all([call(getPwa)]);
}
